/**
 * Authentication Selectors
 * 
 * Memoized selectors for accessing auth state
 */

import type { RootState } from '../../store/storeTypes';

export const selectAuth = (state: RootState) => state.auth;

export const selectIsAuthenticated = (state: RootState) => state.auth.isAuthenticated;

export const selectIsInitialized = (state: RootState) => state.auth.isInitialized;

export const selectIsLoading = (state: RootState) => state.auth.isLoading;

export const selectUser = (state: RootState) => state.auth.user;

export const selectToken = (state: RootState) => state.auth.token;

export const selectPermissions = (state: RootState) => state.auth.permissions;

export const selectError = (state: RootState) => state.auth.error;
